import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import UserAttributesForm from "../UserAttributesForm";
import {
  logCollectUserDataOpened,
  logCollectUserDataSaveBtnClicked,
} from "../../util/analytics";

export const DIALOG_TITLE =
  "Please provide the information requested below so we may complete your account setup.";
export const DIALOG_DESCRIPTION =
  "We will keep your information secure and not request it again. Thank you for your cooperation.";

const CollectUserDataDialog = ({ attributes }) => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    logCollectUserDataOpened();
  }, []);

  const isFieldEditable = (name) => !attributes[name]?.trim();

  const onSubmit = () => {
    logCollectUserDataSaveBtnClicked();
    setIsOpen(false);
  };

  return (
    <UserAttributesForm
      isOpen={isOpen}
      attributes={attributes}
      isInputEditable={isFieldEditable}
      isSelectEditable={isFieldEditable}
      handleSubmit={onSubmit}
      title={DIALOG_TITLE}
      doesTitleHaveBorder={true}
      description={DIALOG_DESCRIPTION}
      hasCloseButton={false}
      onRequestClose={() => {}}
    />
  );
};

CollectUserDataDialog.propTypes = {
  attributes: PropTypes.object.isRequired,
};
export default CollectUserDataDialog;
